<!-- Full Page Intro -->
<div class="view">

  <video class="video-fluid z-depth-1" autoplay loop controls muted>
    <source src="assets/img/Lines.mp4" type="video/mp4" />
  </video>

  <!-- Mask & flexbox options-->
  <div class="mask rgba-black-light" style="padding-top:5em; padding-bottom:5em;">

    <!-- Content -->
    <div class="wow fadeIn">

      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-8 col-md-10 col-lg-6 py-5 px-5" style="background: rgba(255,255,255,0.1); color: whitesmoke">
            <app-title title="One step beyond Factor Investing" priority="2"></app-title>

            Factor-Based Investing’s revolutionary tools help investment advisors build state-of-the-art portfolios. Analytics can be generated and customized on the fly in order to satisfy investors constraints.

            <br /><br />

            <div class="row">
              <div class="col-10">
                <span class="float-right">
                  <app-line-button green>Learn more</app-line-button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- Content -->

  </div>
  <!-- Mask & flexbox options-->

</div>
<!-- Full Page Intro -->

<!--Map Section-->
<app-section header="Funds" title="Assets Under Management">

  <app-map-chart></app-map-chart>

</app-section>
<!--Map Section-->

<!--Process Section-->
<app-section header="Factor-Based Investing" title="Process">

  <div class="flex-center">
    <img src="assets/img/process.png" alt="Factor Investing Process" width="700">
  </div>

</app-section>
<!--Process Section-->

<!--Tools Section-->
<app-section header="Tools" title="Improving Factor Diversification">

  <!--Carousel Wrapper-->
  <div id="carousel-example-0" class="carousel slide carousel-fade" data-ride="carousel">
    <!--Slides-->
    <div class="carousel-inner" role="listbox">
      <div class="carousel-item active" style="height:480px;">
        <div class="col">
          <div class="row h-100">
            <div class="col-7 tools-carousel-img" style="background-image:url(assets/img/ampoules.jpg)">
            </div>
            <div class="col-5 px-4 py-4 dark-light-grey-bg">
              <app-title header="First step" title="Analytics" priority="4"></app-title>

              <p>The motivation for the smart beta design comes first and foremost from the limitations of traditional cap-weighted indices, which are exposed to risk factors that are unrewarded and poorly diversified. In addition, academic research has shown that while it is pointless to try to estimate expected returns, it is possible and important to base the allocation on a robust estimation of risk. This choice of estimating risks rather than returns has thus led to the implementation of a dynamic risk allocation.</p>

              <br />

              <div class="row">
                <div class="col-9">
                        <span class="float-right">
                          <app-line-button green>Learn more</app-line-button>
                        </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="carousel-item">
        <div class="col">
          <div class="row h-100">
            <div class="col-7 tools-carousel-img" style="background-image:url(assets/img/Jenkins.jpg)">
            </div>
            <div class="col-5 px-4 py-4 dark-light-grey-bg">
              <app-title header="Second step" title="Strategy Builder" priority="4"></app-title>

              <p>Strategic allocations should seek to harvest the long-term risk premia associated with a diversity of non-redundant rewarded risk factors whose existence and persistence have been documented by empirical studies and economic rationales - respecting parsimonious factor definitions validated by independent academic research protects investors against the robustness risks of proprietary back-tested, and possibly data-mined, factor innovations.</p>

              <br />

              <div class="row">
                <div class="col-9">
                        <span class="float-right">
                          <app-line-button green>Learn more</app-line-button>
                        </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="carousel-item">
        <div class="col">
          <div class="row h-100">
            <div class="col-7 tools-carousel-img" style="background-image:url(assets/img/IS.jpg)">
            </div>
            <div class="col-5 px-4 py-4 dark-light-grey-bg">
              <app-title header="Third step" title="Investable Solution" priority="4"></app-title>

              <p>Factor portfolios, like all portfolios, should diversify specific risk so as to increase long-term risk-adjusted performance associated with the factor exposure and improve performance robustness by reducing short- and medium-term risks.</p>
              <p>Top-down multi-factor portfolio construction provides explicit and transparent control over individual factor sleeves and affords the flexibility required for dynamic allocation on the basis of risk characteristics.</p>

              <br />

              <div class="row">
                <div class="col-9">
                        <span class="float-right">
                          <app-line-button green>Learn more</app-line-button>
                        </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/.Slides-->

    <br />

    <div class="row">
      <div class="col-8" style="height:300px">
        <!--Descriptions-->
        <div class="carousel-description-0 h-100">
          <div class="col h-100">
            <app-title header="Investment philosophy" title="Factor Diversification and Market Conditionality" priority="3"></app-title>

            <p> These three key principles are drawn from the academic origins. The motivation for the smart beta design comes first and foremost from the limitations of traditional cap-weighted indices, which are exposed to risk factors that are unrewarded and poorly diversified. In addition, academic research has shown that it is important to base the allocation on a robust estimation of risk.</p>

            <br /><br />

            <em style="font-size: 0.8em;">A challenging venture</em>

            <div class="row">
              <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Try it now</app-line-button>
                      </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Controls-->
      <div class="col pl-4" style="height:300px; border-left: 1px solid #aaa">
        <a class="blue-link" (click)="showToolsSlide(0)"><h5>Analytics</h5></a>
        <em style="font-size: 0.8em;">To offer a relevant diagnosis of the existing portfolio’s risks and diversification</em>
        <br /><br />
        <a class="blue-link" (click)="showToolsSlide(1)"><h5>Strategy Builder</h5></a>
        <em style="font-size: 0.8em;">To construct a completeness portfolio to reach the target factor allocation</em>
        <br /><br />
        <a class="blue-link" (click)="showToolsSlide(2)"><h5>Investable Solution</h5></a>
        <em style="font-size: 0.8em;">Transforming a factor representation into an investment through funds or mandates</em>
      </div>
    </div>
    <!--Controls-->
  </div>
  <!--/.Carousel Wrapper-->

</app-section>
<!--Tools Section-->

<!-- Peers Section--
<app-peers-widget></app-peers-widget>
!-- Peers Section-->

<!--Webinars Section-->
<app-section header="Resources" title="Sharing knowledge">

  <div class="row">
    <div class="col-12" style="position:relative">
      <div style="background:rgba(255,255,255,0.25); z-index:2;padding:6px 65px 6px 35px; font-size: 0.8em; position:absolute; top:5px; right:20px">
              <span>
                <app-line-button>Knowledge center</app-line-button>
              </span>
      </div>
    </div>
  </div>

  <!--Carousel Wrapper-->
  <div id="carousel-example-2" class="carousel slide carousel-fade" data-ride="carousel">
    <!--Slides-->
    <div class="carousel-inner" role="listbox">
      <div class="carousel-item active">
        <div class="view">
          <img class="d-block w-100 h-100" src="assets/img/webinars_2.jpeg" alt="Webinar">
          <div class="mask rgba-black-slight"></div>
        </div>
        <div class="carousel-caption text-left" style="height:300px; width:88%">
          <div class="offset-2 col-9 py-4 px-4 h-100" style="background: rgba(0,0,0,0.75)">
            <img src="assets/img/12.png" class="float-left" style="height:185px; margin-right:15px" alt="Anna Aston - MSCI">

            In our 30-minute session, we’ll examine how factors have historically driven returns across asset classes, how to use factors to seek resilience, and simple ways to explain them to your clients.

          </div>
        </div>
      </div>
      <div class="carousel-item">
        <div class="view">
          <img class="d-block w-100 h-100" src="assets/img/edhec-risk-conference.jpg" alt="Risk Conference">
          <div class="mask rgba-black-slight"></div>
        </div>
        <div class="carousel-caption text-left" style="height:300px; width:88%">
          <div class="offset-2 col-9 py-4 px-4 h-100" style="background: rgba(0,0,0,0.75)">
            <img src="assets/img/11.jpeg" class="float-left" style="height:185px; margin-right:15px" alt="Anna Aston - BlackRock">

            Factor investing has brought disruptive change to the asset management industry. The effects were first felt in equities, but Factor investing is now going multi-asset class. Factor-based asset allocation and systematic strategy factors are starting to push beyond equity selection. The next webinar in our Factor Investing series will highlight our latest Factor Innovation, the MSCI Multi-Asset Class Factor Model, which helps investors more clearly identify the drivers of risk and return in these complex, dynamic strategies.

          </div>
        </div>
      </div>
      <div class="carousel-item">
        <div class="view">
          <img class="d-block w-100 h-100" src="assets/img/webinars_3.jpeg" alt="Webinar">
          <div class="mask rgba-black-slight"></div>
        </div>
        <div class="carousel-caption text-left" style="height:300px; width:88%">
          <div class="offset-2 col-9 py-4 px-4 h-100" style="background: rgba(0,0,0,0.75)">
            <img src="assets/img/10.jpg" class="float-left" style="height:185px; margin-right:15px" alt="Anna Aston - FTSE">

            The new FTSE Target Exposure Indexes are a suite of benchmarks designed to focus on specific characteristics— such as factor, climate and ESG exposures—while minimizing all off-target, consequential exposures, to deliver a “near pure” index. Target exposures are completely flexible and can be combined to cater to specific client objectives and investment outcomes.

          </div>
        </div>
      </div>
    </div>
    <!--/.Slides-->

    <br />

    <div class="row">
      <div class="col-6" style="height:330px">
        <!--Descriptions-->
        <div class="carousel-description-2 h-100">
          <div class="col h-100">
            <app-title header="Details" title="Webinar series also available on our corporate YouTube channel" priority="4"></app-title>

            As we believe that smart beta is a new frontier for the investment industry, research and education on this subject are a core part of our strategy. We have therefore also made available our series of webinars on the subject of smart beta investing on our corporate YouTube channel...

            <br><br>
            <em style="font-size: 0.8em;">January 21st, 2019</em>

            <div class="row">
              <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Learn more</app-line-button>
                      </span>
              </div>
            </div>

            <br />
          </div>

          <div class="col h-100 d-none">
            <app-title header="Details" title="A More Robust Defensive Offering" priority="4"></app-title>

            This webinar will review Smart Beta's defensive offering which is motivated by a strong belief that investors are not identical and that their investment objectives and constraints are different. The Smart Beta approach allows investors to benefit from the Low Volatility factor reward...

            <br><br>
            <em style="font-size: 0.8em;">April 4th, 2019 – 4.00pm</em>

            <div class="row">
              <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Learn more</app-line-button>
                      </span>
              </div>
            </div>

            <br />
          </div>

          <div class="col h-100 d-none">
            <app-title header="Details" title="On the Importance of Taking Hidden Risks into Account for Factor Investing" priority="4"></app-title>

            As we believe that smart beta is a new frontier for the investment industry, research and education on this subject are a core part of our strategy. We have therefore also made available our series of webinars on the subject of smart beta investing on our corporate YouTube channel...

            <br><br>

            <em style="font-size: 0.8em;">January 17th, 2019 – 4.00pm</em>

            <div class="row">
              <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Learn more</app-line-button>
                      </span>
              </div>
            </div>
          </div>
        </div>
        <!--Descriptions-->
      </div>

      <!--Controls-->
      <div class="col pl-5" style="height:330px; border-left: 1px solid #aaa">
        <small class="card-text">Recent resources</small>
        <br /><br />
        <em style="font-size: 0.8em;">Anna Aston - MSCI – January 21st, 2019</em>
        <a class="blue-link" (click)="showResourcesSlide(1)"><h5 class="text-primary">Webinar series also available on our corporate YouTube channel</h5></a>
        <br />
        <em style="font-size: 0.8em;">Anna Aston - BlackRock – April 4th, 2019 – 4.00pm</em>
        <a class="blue-link" (click)="showResourcesSlide(0)"><h5 class="text-primary">A More Robust Defensive Offering</h5></a>
        <br />
        <em style="font-size: 0.8em;">Anna Aston - FTSE – January 17th, 2019 – 4.00pm</em>
        <a class="blue-link" (click)="showResourcesSlide(2)"><h5 class="text-primary">On the Importance of Taking Hidden Risks into Account for Factor Investing</h5></a>
      </div>
    </div>
    <!--Controls-->
  </div>
  <!--/.Carousel Wrapper-->

</app-section>
<!--Webinars Section-->

<!--News and Events Section-->
<app-section header="News & events" title="About factor investing industry">

  <div class="row">
    <div class="col-12" style="position:relative">
      <div style="background:rgba(255,255,255,0.1); z-index:2;padding:6px 65px 6px 35px; font-size: 0.8em; position:absolute; top:5px; right:20px">
                <span>
                  <app-line-button>All news & events</app-line-button>
                </span>
      </div>
    </div>
  </div>

  <!--Carousel Wrapper-->
  <div id="carousel-example-1" class="carousel slide carousel-fade" data-ride="carousel">
    <!--Slides-->
    <div class="carousel-inner" role="listbox">
      <div class="carousel-item active">
        <div class="view">
          <img class="d-block w-100 h-100" src="assets/img/news_events_1.png" alt="News Event">
          <div class="mask rgba-black-slight"></div>
        </div>
        <div class="carousel-caption text-left" style="height:300px">
          <div class="col-12 py-3 px-5 h-100" style="background: rgba(0,0,0,0.75)">
            <app-title header="Forthcoming event" title="Factor Investing is being held to a new standard." priority="3"></app-title>

            Factor Investing is transforming the way investors construct and manage portfolios. The increasing popularity of Factor Investing can create the need for standards. MSCI FaCS creates a common language for Factor Investing and brings clarity to the confusion of Smart Beta.

            <br><br>
            <em style="font-size: 0.8em;">21 March, 2019 – 3.00pm</em>

            <div class="row">
              <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Join and learn</app-line-button>
                      </span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="carousel-item">
        <div class="view">
          <img class="d-block w-100 h-100" src="assets/img/news_events_2.png" alt="News Event">
          <div class="mask rgba-black-slight"></div>
        </div>
        <div class="carousel-caption text-left" style="height:300px">
          <div class="col-12 py-3 px-5 h-100" style="background: rgba(0,0,0,0.75)">
            <app-title header="News" title="How factor investing fits into active vs passive" priority="3"></app-title>

            Why factor investing makes sense. Altaf Kassam, MSCI Head of Index Applied Research EMEAI. Factors are shown to outperform historically and their outperformance can be explained. It is suitable for passive and active investors.

            <br><br>
            <em style="font-size: 0.8em;">15 March, 2019</em>

            <div class="row">
              <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Join and learn</app-line-button>
                      </span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="carousel-item">
        <!--Mask color-->
        <div class="view">
          <img class="d-block w-100 h-100" src="assets/img/news_events_3.png" alt="News Event">
          <div class="mask rgba-black-slight"></div>
        </div>
        <div class="carousel-caption text-left" style="height:300px">
          <div class="col-12 py-3 px-5 h-100" style="background: rgba(0,0,0,0.75)">
            <app-title header="Past event" title="Smart Beta Day Germany 2019" priority="3"></app-title>

            The Smart Beta Day Germany 2019 will enable asset owners and their direct investment consultants and financial advisors to access...

            <br><br>
            <em style="font-size: 0.8em;">Frankfurt – 4 June, 2019</em>

            <div class="row">
              <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Join and learn</app-line-button>
                      </span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="carousel-item">
        <!--Mask color-->
        <div class="view">
          <img class="d-block w-100 h-100" src="assets/img/news_events_4.png" alt="News Event">
          <div class="mask rgba-black-slight"></div>
        </div>
        <div class="carousel-caption text-left" style="height:300px">
          <div class="col-12 py-3 px-5 h-100" style="background: rgba(0,0,0,0.75)">
            <app-title header="Past event" title="Scientific Beta Days North America 2018" priority="3"></app-title>

            This two-day conference will include multiple plenary sessions, workshops and practical sessions allowing professionals to review major...

            <br><br>
            <em style="font-size: 0.8em;">Boston – 25 & 26 October, 2018</em>

            <div class="row">
              <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Join and learn</app-line-button>
                      </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!--/.Slides-->

    <!--Controls-->
    <a class="carousel-control-prev" href="#carousel-example-1" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carousel-example-1" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
    <!--/.Controls-->
  </div>
  <!--/.Carousel Wrapper-->

  <p style="font-size:0.78em">Since we believe that smart beta is a new frontier for the investment industry, research and education on this subject are a core part of educational's strategy. That is why we are also making available on our corporate YouTube channel our series of complimentary webinars on the subject of smart beta investing for interested parties.</p>

</app-section>
<!--News and Events Section-->

<!--About Section--
<app-section header="About us" title="Our Vision">

  <div class="view">
    <div class="offset-4 col-8">
      <img class="img-responsive" src="assets/img/about.png" width="100%" alt="About us">
    </div>
    <div class="mask">

      <div class="col-12 col-lg-7">
        <br /><br />
        <div class="col" style="background-color: rgba(50,50,50,0.8)">
          <br />
          <app-title title="Make the word a better place" priority="3"></app-title>
          <p>In an ever-changing world, managers must become true entrepreneurs who are prepared to rip the rulebook apart. Giving tomorrow’s leaders the knowledge, the mind-set and the agility to invent new paths are at the heart of our vision. And we believe this litheness starts by developing employees’ soft skills. More than a company that trains in business, we are an ecosystem that innovates by stimulating an entrepreneurial spirit, a springboard towards a better future that prioritizes people.</p>
          <p>Thought leadership: knowledge creation fueled by applied research, and the constantly-updated full-range academic programmes...</p>

          <div class="row">
            <div class="col-10">
                  <span class="float-right">
                    <app-line-button green>Learn more</app-line-button>
                  </span>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</app-section>
!--About Section-->

<!-- Footer -->
<footer class="page-footer">

  <!-- Copyright -->
  <div class="text-center">
    <p style="color: slategrey">© 2020 Copyright: <strong>www.factor-based-investing.com</strong></p>
  </div>
  <!-- Copyright -->

</footer>
<!-- Footer -->
